import { categories, categoryImages } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section id="categories" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold tracking-wider uppercase mb-3">
            Explore Categories
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Vigorbuy Spreadsheet Product Categories
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            Browse our complete collection of product categories. Each category connects you to organized product listings for smarter shopping research.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => {
            const imgSrc = categoryImages[cat.name];
            return (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col rounded-xl bg-background-50 hover:bg-background-50 border border-background-200/60 hover:border-accent-300/60 transition-all duration-300 cursor-pointer overflow-hidden"
              >
                {imgSrc && (
                  <div className="relative w-full h-28 md:h-32 overflow-hidden">
                    <img
                      src={imgSrc}
                      alt={`${cat.name} category products`}
                      title={`${cat.name} - Vigorbuy Spreadsheet Category`}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                  </div>
                )}
                <div className="flex flex-col items-center gap-2 p-3 md:p-4 text-center flex-1">
                  <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-accent-50 group-hover:bg-accent-100 transition-colors">
                    <i className={`${cat.icon} text-accent-600 text-base md:text-lg group-hover:scale-110 transition-transform duration-300`}></i>
                  </div>
                  <p className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-foreground-950 transition-colors leading-snug">
                    {cat.name}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}